const STATE = {
  sources: [],
  tables: [],
  selectedItem: null,
  selectedType: null,
  entityRelations: [],
  entityRelationsLoading: false,
  columnsLoading: false,
  sourceTables: [],
  sourceTablesLoading: false,
};
  
export default STATE;